import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="device-meta"
// Sets viewport meta tag based on device width
export default class extends Controller {
  connect() {
    this.setViewport()
  }

  setViewport() {
    // Get device width - prefer jQuery if available, fallback to window.innerWidth
    let deviceWidth
    if (window.jQuery && typeof window.jQuery(window).width === 'function') {
      deviceWidth = window.jQuery(window).width()
    } else {
      deviceWidth = window.innerWidth || document.documentElement.clientWidth
    }

    // Only set viewport meta for specific width ranges (matching original deviceMeta behavior)
    if (deviceWidth <= 1024 && deviceWidth >= 768) {
      // Remove existing viewport meta if any (to avoid duplicates)
      const existingMeta = document.querySelector('meta[name="viewport"]')
      if (existingMeta) {
        existingMeta.remove()
      }

      const meta = document.createElement('meta')
      meta.name = 'viewport'
      meta.content = 'width=1024, initial-scale=0.70'
      document.head.appendChild(meta)
    } else if (deviceWidth <= 767) {
      // Remove existing viewport meta if any (to avoid duplicates)
      const existingMeta = document.querySelector('meta[name="viewport"]')
      if (existingMeta) {
        existingMeta.remove()
      }

      const meta = document.createElement('meta')
      meta.name = 'viewport'
      meta.content = 'width=700, initial-scale=0.30'
      document.head.appendChild(meta)
    }
    // For widths > 1024, don't set viewport meta (matching original behavior)
  }
}
